module.exports = __webpack_public_path__ + "img/gy.e25b0480.png";